import React, { Fragment } from "react";

import ModalClose from "./ModalClose";

const Modal = props => (
  <Fragment>
    <div className="modal__header">
      <span>{props.title}</span>
    </div>

    <div className="modal__body">
      <ModalClose handleClick={props.handleClose} />
      {props.children}
    </div>
  </Fragment>
);

export  default Modal;



// WEBPACK FOOTER //
// ./src/components/modals/Modal.js